module.exports = __webpack_public_path__ + "static/heritage_350-878d606bc70b0d0f5d38857d2df897bc.webp";